import { query } from '@warp-drive/utilities/json-api';
import type { Store as StoreService } from '@warp-drive/core';
import type { Company as CompanyModel } from 'tio-data/data/resources/company.type';
import type { CompanyOption } from '../services/reports-catalog.ts';

/**
 * Active companies as picker options, sorted by name, from one request capped at 400 — the
 * dashboard builder's scope selector and the dashboard viewer's company picker share it.
 * `key` is the company id as a string, which is how both compare it to a saved scope.
 *
 * @throws when the request fails; a trackedFunction caller surfaces that as its error state
 */
export async function loadActiveCompanyOptions(store: StoreService): Promise<CompanyOption[]> {
  const { content } = (await store.request(
    query<CompanyModel>('company', {
      'filter[is-active]': 1,
      sort: 'name',
      'page[limit]': 400,
    })
  )) as { content: { data: CompanyModel[] } };
  return content.data.map((c) => ({ key: String(c.id), label: c.name || `Company ${c.id}` }));
}
